export default __webpack_public_path__ + "static/media/SndLowerXSlideDown.d50e5285.mp3";